import { Room, State } from './types';

const getters = {
  getRooms(state: State): Array<Room> {
    let rooms = Object.values(state.rooms);
    rooms = rooms.filter(room => !room.is_breakout && !room.is_booth && !room.owner);
    return rooms.sort((a, b) => a.rank - b.rank);
  },
  getRoomById: (state: State) => (roomId: string) => state.rooms[roomId]
};

export default getters;
